import React from 'react';

import { SectionFormProvider } from 'contexts/section-form.context';
import ManageSectionFormContent from './content';

const ManageSectionFormLayout = () => {
  return (
    <SectionFormProvider>
      <ManageSectionFormContent />
    </SectionFormProvider>
  );
};

export default ManageSectionFormLayout;
